import lozad from 'lozad';

(function () {
	const observer = lozad(`.person-portfolio .carousel`, {
		load(el) {
			const carousel_cell_els = el.getElementsByClassName(`carousel-cell`);
			if (carousel_cell_els.length <= 1) {
				return;
			}

			import(`flickity`).then(({ default: Flickity }) => {
				new Flickity(el, {
					wrapAround: true,
					// autoPlay: 5000,
					cellAlign: `left`,
					adaptiveHeight: true,
					pageDots: true,
					prevNextButtons: true,
				});
			});
		},
	});

	observer.observe();
})();
